import React from "react";

// 受注数/納品予定ヘッダ描画をまとめて返す。
export function createDemandHeaderRenderer(deps) {
    const {
        PANEL_TYPE,
        entrydataRef,
        findEntryValue,
        resolveDemandHeaderFallbackValue
    } = deps;

    // 受注数/納品予定の上部情報表示を描画する。
    function renderDemandHeader(sectionId) {
        const code = String(findEntryValue(entrydataRef.current, [
            "PDT_SYOHINCD", "SJCM_HINBAN", "SSD_SYOHINCD"
        ]) ?? "");

        if (sectionId === "jutyusu") {
            const tenjiNo = resolveDemandHeaderFallbackValue("jutyusu", [
                "SJC_TENJINO"
            ], PANEL_TYPE.JUTYUSU, "jutyusu");
            const tenjiNm = resolveDemandHeaderFallbackValue("jutyusu", [
                "TNJ_NAME"
            ], PANEL_TYPE.JUTYUSU, "jutyusu");
            return (
                <div className="kakousiji-demand-header">
                    <div className="kakousiji-demand-header__headline">
                        <div className="kakousiji-demand-header__block">
                            <div className="kakousiji-demand-header__title kakousiji-demand-header__title--jutyu">展示会No</div>
                            <div className="kakousiji-demand-header__value kakousiji-demand-header__value--jutyu">{tenjiNo}</div>
                        </div>
                        <div className="kakousiji-demand-header__block">
                            <div className="kakousiji-demand-header__title kakousiji-demand-header__title--jutyu">展示会名称</div>
                            <div className="kakousiji-demand-header__value kakousiji-demand-header__value--jutyu">{tenjiNm}</div>
                        </div>
                    </div>
                    <div className="kakousiji-demand-header__code kakousiji-demand-header__code--jutyu">品番 {code}</div>
                </div>
            );
        }

        if (sectionId === "nouhinyotei") {
            const shijiNo = String(findEntryValue(entrydataRef.current, [
                "SSDNY_NO", "SSD_NO", "SSD_SIJINO"
            ]) ?? "");
            return (
                <div className="kakousiji-demand-header kakousiji-demand-header--nouhin">
                    <div className="kakousiji-demand-header__line">
                        <span className="kakousiji-demand-header__line-label">品番</span>
                        <span className="kakousiji-demand-header__line-colon">：</span>
                        <span className="kakousiji-demand-header__line-value">{code}</span>
                    </div>
                    <div className="kakousiji-demand-header__line kakousiji-demand-header__line--last">
                        <span className="kakousiji-demand-header__line-label">加工指示番号</span>
                        <span className="kakousiji-demand-header__line-colon">：</span>
                        <span className="kakousiji-demand-header__line-value">{shijiNo}</span>
                    </div>
                </div>
            );
        }

        return null;
    }

    return {
        renderDemandHeader
    };
}
